export default __webpack_public_path__ + "9c59918b3c8584b9fb34cdc45ea97d06.png";